<template>
  <div class="mt-16 pr-10">
    <div class="items-baseline sticky" style="width: 200px; top: 80px">
      <div>
        <h3
          class="text-base leading-8 pl-6 mb-6 font-semibold text-gray-92 border-l-2 border-secondary-main"
        >
          企業情報
        </h3>
      </div>
      <nav class="mb-12">
        <ul class="ml-10">
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.profile &&
                  state.scrollY < state.tops.summary,
              }"
              v-scroll-to="{ el: '#profile' }"
            >
              プロフィール
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.summary &&
                  state.scrollY < state.tops.management,
              }"
              v-scroll-to="{ el: '#summary' }"
            >
              企業概要
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.management &&
                  state.scrollY < state.tops.location,
              }"
              v-scroll-to="{ el: '#management' }"
            >
              経営データ
            </span>
          </li>
          <li class="mb-2">
            <span
              class="text-sm cursor-pointer text-gray-62"
              :class="{
                'text-gray-92 font-semibold':
                  state.scrollY >= state.tops.location,
              }"
              v-scroll-to="{ el: '#location' }"
            >
              企業所在地
            </span>
          </li>
        </ul>
      </nav>
      <div class="flex flex-col">
        <button
          class="text-sm text-white rounded flex px-4 py-2 mb-2 items-center focus:outline-none"
          style="background-color: #de2d2d; width: 200px; height: 40px"
          @click="showModal('preview')"
        >
          <span>プレビュー</span>
          <span class="ml-auto"
            ><img src="@/assets/icons/OpenWhite.svg" style="width: 12px"
          /></span>
        </button>
        <button
          v-if="hasPublished"
          class="text-sm bg-white rounded flex px-4 py-2 items-center text-gray-92 focus:outline-none"
          style="width: 200px; height: 40px"
          @click="showModal('public')"
        >
          <span>公開中の情報</span>
          <span class="ml-auto"
            ><img src="@/assets/icons/OpenGray.svg" style="width: 12px"
          /></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, onUnmounted } from 'vue';

export default {
  props: ['hasPublished'],
  emits: ['show-modal'],
  setup(props, { emit }) {
    const state = reactive({
      scrollY: 0,
      tops: {},
    });
    const showModal = (dataType) => {
      emit('show-modal', dataType);
    };
    const scroll = () => {
      const pageYOffset = window.pageYOffset - 55;
      state.tops = {
        profile:
          document.querySelector('#profile').getBoundingClientRect().top +
          pageYOffset,
        summary:
          document.querySelector('#summary').getBoundingClientRect().top +
          pageYOffset,
        management:
          document.querySelector('#management').getBoundingClientRect().top +
          pageYOffset,
        location:
          document.querySelector('#location').getBoundingClientRect().top +
          pageYOffset,
      };
      state.scrollY = window.scrollY;
    };
    onMounted(() => {
      window.addEventListener('scroll', scroll);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', scroll);
    });
    return {
      state,
      showModal,
    };
  },
};
</script>
